export function downloadNewFile(
  fileName: string,
  fileType: string,
  data: string,
) {
  const file = createFile(fileType, data)
  const link = window.URL.createObjectURL(file)

  downloadFile(link, fileName)
}

function downloadFile(link: string, fileName: string) {
  const element = window.document.createElement("a")
  element.href = link
  element.download = fileName
  document.body.appendChild(element)

  element.click()

  window.URL.revokeObjectURL(element.href)
  document.body.removeChild(element)
}

function createFile(type: string, data: string) {
  return new Blob([data], { type })
}
